<template>
  <div>
    <!-- 添加 -->
    <template>
      <Modal v-model="visible" title="绑定系统账号" draggable class-name="vertical-center-modal" ok-text="绑定" width="530" height="300"
        style="overflow: hidden;" @on-ok="ok" @on-cancel="cancel" :loading="loading">
        <Form ref="details" :model="details" :rules="ruleValidate" label-position="right" :label-width="180" style="width: 514px; height: 200px; margin: 0 auto; overflow-y: auto; padding-top: 20px;">
          <div style="margin-top: 20px"></div>

          <Row span="24">
            <Col span="20">
            <FormItem label="该系统登录账号" prop="systemLoginCode">
                <Input v-model="details.systemLoginCode" placeholder="请输入系统登录账号"></Input>
            </FormItem>            
            </Col>
          </Row>
            <div style="margin-top: 20px"></div>

          <Row span="24">
            <Col span="20">
            <FormItem label="该系统登录密码" prop="systemPassword">
                <Input v-model="details.systemPassword" type="password" password  placeholder="请输入系统登录密码"></Input>
            </FormItem>            
            </Col>
          </Row>

        </Form>
      </Modal>
    </template>
  </div>
</template>

<script>
  export default {
    props: {
      isShow: {
        type: Boolean,
        default: false
      },
      details: {
        type: Object,
        default: () => {
          return {}
        }
      },
      systemName: {
        type: String,
        default: ''
      }
    },
    data() {
      return {
        visible: false,
        formLeft: {},
        loading: true,

        ruleValidate: {
          systemLoginCode: [{ required: true, message: '系统登录账号不能为空', trigger: 'blur' }],
          systemPassword: [{ required: true, message: '系统登录密码不能为空', trigger: 'blur' }]
        }
      }
    },
    watch: {
      isShow(newValue, old) {
        this.visible = newValue;
      }
    },
    mounted() {

    },
    methods: {

      ok(value) {
        let _this = this;
        _this.$refs.details.validate(valid => {
            if (valid) {
                _this.$emit("on-change", false, _this.details);
            } else {
                _this.$Message.error("请输入必填项");
                _this.loading = false;
                _this.$nextTick(() => {
                    _this.loading = true;
                });
            }
        });

      },
      cancel(value) {
        this.$emit("on-change", this.visible)
      }
    },
  }
</script>

<style scoped="scoped">

</style>
